define('modules/ProductSelector/ProductSelector',[
    'jquery',
    'global/all',
    'plugins/jquery-ui.min',
    'plugins/jquery.proxyRequest',
], function ($, Roc) {
    'use strict';

    var viewModel;
    var searchUrl;

    var btns = {
        productSelectorSearch: '[data-roc-action="search"]',
        productSelectorClear: '[data-roc-action="clear"]'
    };

    function getParams() {
        var params = {
            'clear_all_url': window.location.pathname
        };
        $('#productSelectorWrapper').find("select").each(function () {
            var value = $(this).val();
            if (value) {
                var attributeCode = $(this).attr('data-attribute-code');
                params[attributeCode] = value;
            }
        });

        if (viewModel.categories) {
            params['Category'] = viewModel.categories;
        }

        return params;
    }

    function getSelections() {
        var params = getParams();
        Roc.UI.block('#productSelectorWrapper');
        $.proxyRequest({
            type: 'POST',
            url: '/api/productselector/' + viewModel.id,
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(params),
            dataType: 'json',
            complete: function (xhr) {
                if (xhr.status === 200) {
                    var response = xhr.responseJSON || {};
                    viewModel = response;
                    load();
                    Roc.UI.unblock('#productSelectorWrapper');
                }
            }
        });
    }

    function reloadSelectionsEvt() {
        $(document)
            .off('change', '#productSelectorWrapper select')
            .on('change',
                '#productSelectorWrapper select',
                function () {
                    getSelections();
                });
    }

    function submitFormEvt() {
        Roc.UI.siteBody
            .off('click', btns.productSelectorSearch)
            .on('click',
                btns.productSelectorSearch,
                function () {
                    // adding current pst url to parameters to be used by hawk search
                    var params = getParams();
                    var redirectUrl = Roc.UrlHelper.buildUrlWithQueryString(searchUrl, params);
                    redirectUrl = redirectUrl.replaceAll("%2C", "%25c%25");
                    window.location.href = redirectUrl;
                });

        Roc.UI.siteBody
            .off('click', btns.productSelectorClear)
            .on('click', btns.productSelectorClear, function () {
                $('#productSelectorWrapper').find(':input').each(function () {
                    switch (this.type) {
                        case 'select-multiple':
                        case 'select-one':
                        case 'text':
                        case 'textarea':
                            $(this).val('');
                            break;
                        case 'checkbox':
                        case 'radio':
                            this.checked = false;
                    }
                });
                getSelections();
            });
    }

    function bindEvents() {
        submitFormEvt();
        reloadSelectionsEvt();
    }

    function load() {
        Roc.UI.template("productSelector-Tmp",
            viewModel
        ).then(function (renderedTemplate) {
            $("#productSelectorWrapper").html(renderedTemplate);
        });
    }

    function init(options) {
        viewModel = options.model;
        searchUrl = options.searchUrl;
        if (searchUrl && searchUrl.substr(-1) != '/') {
            searchUrl += '/'
        }
        load();
        bindEvents();
    };

    var ProductSelector = {
        init: init
    };

    return ProductSelector;
});
